import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import styled from '@emotion/styled';
import React from 'react';
import PropTypes from 'prop-types';
// swiper core styles
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';

import { logAmplitude } from '../../utils/amplitude';

const TrustMarkCarouselWrapper = styled.div`
  .swiper-pagination {
    bottom: 0;
  }

  .swiper-slide {
    width: 84%;
    margin: 1.6rem 0 1.6rem 1.6rem;
  }
  .swiper-slide:last-child {
    margin-right: 1.6rem; 
  }
  .swiper-pagination-bullet {
    height: 0.8rem;
    width: 0.8rem;
    background-color: ${({ theme }) => theme.color.bluePrimary};
    border-radius: 50%;
    display: inline-block;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
`;

const ReviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 18.5px;
  background: #ffffff;
  box-shadow: 0px 0.4rem 1.6rem rgba(0, 0, 0, 0.03);

  font-family: ${({ theme }) => theme.font.heading};
  font-size: 2.4rem;
  line-height: 3.2rem;
  font-weight:300;
  color: ${({ theme }) => theme.color.bluePrimary};
  text-align: start;
  height: 172px;
  margin-bottom: 1.6rem;
`;

SwiperCore.use([Pagination]);

const TrustMarkCarousel = (props) => {
  const reviews = [
    `“I am very happy with the quality of their clothes and truly appreciate their level of customer service.”`,
    `“Wow! I've never received this level of customer service before! I wish all companies would follow suit.”`,
    `“Excellent customer service and communication. Fast shipping.”`,
    ` “Ordering is easy and acknowledged quickly. Product selection cannot be beat. Customer Service is fast,
    efficient, so helpful!”`
  ];

  const handleOnSlideChange = () => {
    logAmplitude('PDP Interaction', {
      product: props.product,
      interactionType: 'customer quote swipe',
      image: props.product.master?.images[0]?.product_url
    });
  };

  return (
    <TrustMarkCarouselWrapper>
      <Swiper
        slidesPerView={'auto'}
        modules={[Pagination]}
        pagination={{ clickable: true }}
        onSlideChange={handleOnSlideChange}>
        {reviews.map((review, reviewIndex) => (
          <SwiperSlide key={`CarouselQuote${reviewIndex}`}>
            <ReviewContainer>{review}</ReviewContainer>
          </SwiperSlide>
        ))}
      </Swiper>
    </TrustMarkCarouselWrapper>
  );
};

TrustMarkCarousel.propTypes = {
    product: PropTypes.object.isRequired,
};

export default TrustMarkCarousel;

